@import "shared/design-system/style";

.table {
  width: 100%;
  margin: 0 0 $spacer-medium;
}

.table__content {
  border-radius: 8px;
  overflow: hidden;
  background-color: $white-base;
  border: 1px solid $highlight-subdued;
}

.table {
  .heading {
    margin-bottom: $spacer-medium;
  }
}

.stage__container {
  padding: $spacer-medium;
  background-color: $highlight-background;
  display: flex;
  flex-direction: column;
  gap: $spacer-tiny;
  align-items: center;
  justify-content: center;
  min-width: 200px;
}

.indicator__container {
  display: flex;
  gap: $spacer-large;
  padding: $spacer-medium 0;
  .indicator__item {
    width: 100%;
    .indicator__details {
      .details__item {
        margin-bottom: $spacer-small;
      }
    }
  }
}

.stage__container {
  width: 200px;
  .next_icon {
    font-size: 24px;
  }
  .icon__container {
    background-color: $highlight;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto $spacer-small;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    svg {
      color: $white-base;
      width: 48px;
      height: 48px;
      path {
        stroke: $white-base;
      }
    }
  }
  .card__heading {
    display: block;
    text-align: center;
  }
}

.content__row {
  display: flex;
  column-gap: $spacer-large;
  row-gap: 0;
}

@supports (display: grid) {
  @include breakpoint-larger-than-medium {
    .content__row {
      grid-template-columns: 200px 1fr; //UPDATE THIS
      grid-template-rows: 1fr 1fr;
      .stage__container {
        grid-row: 1 / -1;
      }
    }
  }
}

.indicator__wrapper {
  width: 100%;
  border-bottom: 1px solid $highlight-subdued;
  margin: 0 $spacer-medium 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:last-child {
    border-bottom: none;
  }
}

.editable_content {
  border-radius: 8px;
}
